import { Body } from "@vds/typography";
import SelectFloorPlan from "../../../pages/CameraOnboarding/SelectFloorPlan";
import { getDiscoveredCameras } from "../../../api/DeviceServiceManager";
import { DropdownSelect } from "@vds/selects";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  BIContent,
  BoldText,
  LightText,
} from "../discoveredCameraOnboarding/styles";
import {
  CCD_MODEL_MEDIUM,
  CCD_MODEL_MEDIUM_LIMIT,
  CCD_MODEL_SMALL,
  CCD_MODEL_SMALL_LIMIT,
} from "../../../global/constants/devices";
import {
  clearOnboardingFields,
  fetchCompanion,
  getFovIds,
  setSelectedCompanionFovStreamCounts,
  fetchedUnPairedCameraDevices,
} from "../../../store/actions";
import { Loader } from "@vds/loaders";
import { Icon } from "@vds/icons";

const CompanionSelection = ({
  isPairing,
  onNextDisableChange,
  onBoradType,
}) => {
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { cameraList, fovList, companionDeviceList, discoveredCamerasList } =
    useSelector((state) => state?.deviceReducer);
  let unpairedCameraReducerList = useSelector(
    (state) => state.deviceReducer.discoveredCamerasList
  );
  const { calculatedAvailabilityCount, calculatedStreamCount, modalOpenObj } =
    useSelector((state) => state.cameraOnboardingReducer);
  const {
    companionListByCamera,
    companionLoading,
    companionError,
    companionDevice,
    selectedCamQR,
  } = useSelector((state) => state.cameraOnboardingReducer);
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];
  const fovIdsForSelectedCameraQA = fieldOfViews?.map((item) => item.fovId);
  const editFlow = modalOpenObj?.editFlow;
  useEffect(() => {
    if (companionDevice?.length === 0 || !companionDevice) {
      onNextDisableChange(true);
    }
  }, [companionDevice]);
  useEffect(() => {
    if (onBoradType !== "Manual") {
      setCompanionList(companionListByCamera);
    }
  }, [companionListByCamera, companionDevice, onBoradType]);
  const [
    selectedCompanionFovStreamAvailabilityCount,
    setSelectedCompanionFovStreamAvabilityCount,
  ] = useState(0);
  const [selectedCompanionFovStreamCount, setSelectedCompanionFovStreamCount] =
    useState(0);
  const [isCCDLimitModalVisible, setIsCCDLimitModalVisible] = useState(false);
  const [companionList, setCompanionList] = useState(
    onBoradType === "Manual" ? companionDeviceList : companionListByCamera
  );
  const checkCompanionStreamLimitCounts = (companion) => {
    setIsCCDLimitModalVisible(false);
    const cameraWithSelectedCompanion = cameraList?.filter((camera) => {
      return camera?.parentdeviceid == companion?.id;
    });
    const cameraWithSelectedCompanionIdList = cameraWithSelectedCompanion.map(
      (m) => m?.id
    );

    const fovLsitWithCompanionId = fovList.filter((fov) => {
      return (
        cameraWithSelectedCompanionIdList.indexOf(fov?.parentdeviceid) > -1
      );
    });
    const streamCount = fovLsitWithCompanionId.length;
    let availabilityCount = 0;

    if (
      companion?.productmodel != undefined &&
      CCD_MODEL_SMALL.indexOf(companion?.productmodel?.replaceAll(" ", "")) > -1
    ) {
      if (
        streamCount >= CCD_MODEL_SMALL_LIMIT ||
        fovIdsForSelectedCameraQA.length > CCD_MODEL_SMALL_LIMIT - streamCount
      ) {
        setIsCCDLimitModalVisible(true);
        availabilityCount =
          CCD_MODEL_SMALL_LIMIT - streamCount > 0
            ? CCD_MODEL_SMALL_LIMIT - streamCount
            : 0;
      } else {
        availabilityCount = CCD_MODEL_SMALL_LIMIT - streamCount;
      }
    } else if (
      companion?.productmodel != undefined &&
      CCD_MODEL_MEDIUM.indexOf(companion?.productmodel?.replaceAll(" ", "")) >
        -1
    ) {
      if (
        streamCount >= CCD_MODEL_MEDIUM_LIMIT ||
        fovIdsForSelectedCameraQA.length > CCD_MODEL_MEDIUM_LIMIT - streamCount
      ) {
        setIsCCDLimitModalVisible(true);
        availabilityCount =
          CCD_MODEL_MEDIUM_LIMIT - streamCount > 0
            ? CCD_MODEL_MEDIUM_LIMIT - streamCount
            : 0;
      } else {
        availabilityCount = CCD_MODEL_MEDIUM_LIMIT - streamCount;
      }
    } else {
      if (
        streamCount >= CCD_MODEL_SMALL_LIMIT ||
        fovIdsForSelectedCameraQA.length > CCD_MODEL_SMALL_LIMIT - streamCount
      ) {
        setIsCCDLimitModalVisible(true);
        availabilityCount =
          CCD_MODEL_SMALL_LIMIT - streamCount > 0
            ? CCD_MODEL_SMALL_LIMIT - streamCount
            : 0;
      } else {
        availabilityCount = CCD_MODEL_SMALL_LIMIT - streamCount;
      }
    }

    setSelectedCompanionFovStreamCount(streamCount);
    setSelectedCompanionFovStreamAvabilityCount(availabilityCount);

    dispatch(
      setSelectedCompanionFovStreamCounts(availabilityCount, streamCount)
    );
  };

  const changeCompanion = (event) => {
    const companionName = event.target[event.target.selectedIndex].text;
    const companionValue = event.target.value;
    if (
      companionValue &&
      (!unpairedCameraReducerList || unpairedCameraReducerList.length === 0)
    ) {
      let filteredCompanionDeviceList = companionDeviceList?.filter(
        (item) => item?.id === companionValue
      );
      if (filteredCompanionDeviceList) {
        getDiscoveredCameras({
          companionDeviceList: filteredCompanionDeviceList,
          activeSession: activeSession,
          forcediscovery: false,
        }).then((discoveredCameras) => {
          if (discoveredCameras !== null && discoveredCameras !== undefined) {
            dispatch(fetchedUnPairedCameraDevices(discoveredCameras));
          } else {
            console.error("Response is null or undefined");
          }
        });
      }
    }
    const fovsOfSelectedCompanionCamera = unpairedCameraReducerList?.find(
      (item) =>
        item?.discoveredby === companionValue && item?.qrcode === selectedCamQR
    )?.fovs;
    const FovNames = fovsOfSelectedCompanionCamera?.map((item) => {
      return { fovName: item.fovName, fovId: item.fovID };
    });

    dispatch(getFovIds(FovNames));

    const companion = companionDeviceList?.find(
      (item) => item.id === companionValue
    );
    dispatch(
      clearOnboardingFields(["companionList", "floorObject", "areaObject", "manualAddResponse", "manualAddStatus", "manualApiResponse"])
    );
    checkCompanionStreamLimitCounts(companion);
    dispatch(
      fetchCompanion({
        id: companionValue,
        name: companionName,
        qrcode: companion?.qrcode,
      })
    );
  };

  useEffect(() => {
    if (companionDevice && companionDevice?.id && !editFlow) {
      const companion = companionDeviceList?.find(
        (item) => item?.id === companionDevice?.id
      );
      checkCompanionStreamLimitCounts(companion);
    }
  }, [companionDevice]);

  return (
    <>
      <Loader active={companionLoading} fullscreen={false} />
      <div style={{ display: "flex", gap: "20px", paddingBottom: "10px" }}>
        <Body color="#000000" size="small" viewport="desktop" primitive="span">
          Select the camera companion device the camera is connected to.
        </Body>
      </div>
      <DropdownSelect
        label="Companion device"
        readOnly={editFlow}
        required={true}
        inlineLabel={false}
        onChange={changeCompanion}
        width="100%"
      >
        <option value="">Select</option>
        {companionList &&
          companionList.map((item) => (
            <option
              selected={item?.id === companionDevice?.id}
              key={item?.id}
              value={item?.id}
            >
              {item?.name}
            </option>
          ))}
      </DropdownSelect>
      {!editFlow && companionDevice?.id && (
        <BIContent>
          <BoldText> Companion availability:</BoldText>
          <LightText>
            {calculatedAvailabilityCount + " camera streams."}
          </LightText>
        </BIContent>
      )}

      {!editFlow && companionDevice?.id && (
        <BIContent>
          <LightText> Companion use:</LightText>
          <LightText>{calculatedStreamCount + " camera streams."}</LightText>
        </BIContent>
      )}
      {isCCDLimitModalVisible && (
        <div className="licensemodal-text">
          <Icon name="error" size="small" color="#C44904" />
          <span className="icon-color">
            {`${companionDevice?.name} is at capacity limit. No more cameras can be added to this device.`}
          </span>
        </div>
      )}
    </>
  );
};
export default CompanionSelection;
